namespace OfficeGuy.Inputs {
    export class EmailAddress {
        static Init() {
            $(document).on("input.emailaddress", ".input-ShortText-EmailAddress", function () {
                EmailAddress.Format($(this));
                return true;
            });
        }
        static Format($Input) {
            var OldValue = $Input.val();
            var NewValue = "";
            for (var i = 0; i < OldValue.length; i++) {
                var Char = OldValue[i];
                if (Char == ' ' || Char == '	' || Char == '‏' || Char == '‪' || Char == '‎' || Char == '‬')
                    continue;

                NewValue += Char;
            }
            if ($Input.val() != NewValue)
                $Input.val(NewValue);
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Inputs.EmailAddress.Init();
});